import { useCallback, useMemo } from 'react';

import { ApiAuthHttpResponse, ApiCreateTwoFactorQuestionDto, useApi } from '@/shared/api';
import { log } from '@/shared/utils/log';

type BeneficiaryLoginInputType = {
  jwt: string;
  publicKey: string;
  password: string;
  email: string;
  twoFactorQuestions: ApiCreateTwoFactorQuestionDto[];
};

export const useBeneficiaryLogin = () => {
  const api = useApi();

  const login = useCallback(
    async ({
      jwt,
      publicKey,
      password,
      email,
      twoFactorQuestions,
    }: BeneficiaryLoginInputType): Promise<ApiAuthHttpResponse | undefined> => {
      const res = await api.beneficiaryActivate({
        publicKey,
        password,
        jwt,
        twoFactorQuestions,
      });

      if (!res.data) return undefined;

      try {
        const { data: authData } = await api.login({ email, password });
        if (!authData) return undefined;
        return authData;
      } catch (e) {
        log.error('Error while login via encrypted message');
        return undefined;
      }
    },
    [api],
  );

  return useMemo(() => ({ login }), [login]);
};
